var App = App || {};

App.SpeedBump = (() => {
    'use strict';

    const URI_SCHEMES = ['javascript:', 'mailto:', 'tel:'];
    let modal;
    let bsModal;

    const init = (exemptList = []) => {
        modal = document.getElementById('speed-bump');
        if (!modal) return console.error('Speed bump modal not found');

        bsModal = new bootstrap.Modal(modal);

        document.addEventListener('click', event => {
            const link = event.target.closest('a');
            if (!link) return;

            const { href: url, hostname } = link;
            if (
                hostname !== location.hostname &&
                !exemptList.includes(hostname) &&
                url &&
                !url.startsWith('#') &&
                !isUriScheme(url)
            ) {
                event.preventDefault();
                event.stopPropagation();
                triggerModal(url, link);
            }
        });
    };

    const triggerModal = (url, origin) => {
        bsModal.show();

        const proceedButton = modal.querySelector('[data-speedbump="proceed"]');
        proceedButton.addEventListener('click', () => openNewTab(url), { once: true });

        modal.addEventListener('hidden.bs.modal', () => {
            origin.focus();
            origin.blur();
        }, { once: true });
    };

    const openNewTab = url => {
        bsModal.hide();
        window.open(url, '_blank');
    };

    const isUriScheme = url => URI_SCHEMES.some(scheme => url.startsWith(scheme));

    return { init };
})();